import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';
import { condensedStyles } from 'core/components/theme/condensed-layout';

const styles = (theme) => ({
  modal: {
    width: 720,
    ...condensedStyles(theme, { width: '100%', maxWidth: 720 })
  },
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  title: {
    lineHeight: 1.4,
    marginBottom: theme.spacing(6)
  },
  optionCards: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  optionCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    backgroundColor: theme.colorPalette.beige_50,
    borderRadius: 4,
    padding: theme.spacing(6),
    gap: theme.spacing(4),
    // Reskin: an inset panel inside the modal.
    ...reskinStyles(theme, theme.cardStyles.inset)
  },
  optionCardMain: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(4)
  },
  optionText: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    flex: '1 1 0',
    minWidth: 0
  },
  optionTitle: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    color: theme.colorPalette.green_80
  },
  optionDescription: {
    color: theme.colorPalette.green_100
  },
  actionButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.colorPalette.green_100,
    color: theme.colorPalette.white,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 16,
    padding: theme.spacing(2, 4),
    borderRadius: 4,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    gap: theme.spacing(1),
    '&:hover': {
      backgroundColor: theme.colorPalette.green_90
    },
    // Reskin: a secondary action pill, so dark green isn't a competing action color.
    ...reskinStyles(theme, { ...theme.actionStyles.secondary, borderRadius: 22, padding: theme.spacing(0, 5.5) })
  },
  cardFooter: {
    borderTop: `1px solid ${theme.colorPalette.beige_60}`,
    paddingTop: theme.spacing(4)
  },
  cardFooterText: {
    fontSize: 12,
    lineHeight: 1.5,
    color: theme.colorPalette.green_100
  },
  generatingPdfText: {
    fontWeight: 400,
    fontSize: 12,
    color: theme.colorPalette.orange_50
  },
  footerLink: {
    fontWeight: 400,
    fontSize: 12,
    color: theme.colorPalette.orange_50,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline'
    },
    ...reskinStyles(theme, {
      textDecoration: 'underline',
      textDecorationThickness: '1px',
      '&:hover': { textDecoration: 'underline', textDecorationThickness: '2px' }
    })
  },
  emailButton: {
    width: 156
  },
  downloadButton: {
    width: 205
  },
  buttonIcon: {
    paddingRight: theme.spacing(1)
  },
  emailIcon: {
    paddingBottom: 1
  }
});

export default makeStyles(styles);
